module.exports = __webpack_public_path__ + "static/media/onelogica.1be15a31.png";